// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  border: none;
  color: white;
  padding: 5%;
  width: 150px;
  background: #333333;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}

.chart {
  height: 210px;
  background: #fafafa;
}

.recharts-cartesian-axis-tick-line {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/common/charts/bar-chart/bar-chart.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ","sourcesContent":[".tooltip {\n    border: none;\n    color: white;\n    padding: 5%;\n    width: 150px;\n    background: #333333;\n    border-radius: 8px;\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.chart {\n    height: 210px;\n    background: #fafafa;\n}\n\n.recharts-cartesian-axis-tick-line {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
